<template>
  <Transition name="fade" mode="out-in">
    <div class="relative" v-show="currentGuide">
      <IconButton @click="onClick()" icon="icon-help-circle" color="light"></IconButton>
      <div
        v-if="!hasSeenGuide"
        class="absolute size-2.5 rounded-full bg-red-300 border border-white top-[5px] right-[15px]"
      ></div>
    </div>
  </Transition>
  <IonModal ref="guideModal">
    <IonHeader class="ion-no-border px-[10px]">
      <IonToolbar color="white" class="border-b-2 border-gray-300">
        <IonTitle color="light"><i class="icon-help-circle mr-1"></i> {{ currentGuide?.title || 'Help' }}</IonTitle>
        <IonButtons slot="end">
          <IconButton icon="icon-x" color="primary" @click="guideModal?.$el?.dismiss()"></IconButton>
        </IonButtons>
      </IonToolbar>
    </IonHeader>
    <IonContent :scroll-y="false">
      <component :is="currentGuide?.component"></component>
    </IonContent>
  </IonModal>
</template>

<script setup lang="ts">
import { IonButtons, IonContent, IonHeader, IonModal, IonTitle, IonToolbar } from '@ionic/vue';
import IconButton from '../forms/IconButton.vue';
import DashboardGuide from './guides/DashboardGuide.vue';
import UnitPageGuide from './guides/UnitPageGuide.vue';
import { computed, Component as ComponentClass, useTemplateRef, triggerRef } from 'vue';
import { useRoute } from 'vue-router';
import { computedAsync } from '@vueuse/core';
import { Preferences } from '@capacitor/preferences';
import PropertyPageGuide from './guides/PropertyPageGuide.vue';
import PropertyListGuide from './guides/PropertyListGuide.vue';

const guideModal = useTemplateRef('guideModal');
const route = useRoute();
const Guides: { [key: string]: { title: string; component: ComponentClass } } = {
  'map.dashboard': { title: 'Dashboard', component: DashboardGuide },
  'unit-page': { title: 'Unit Page', component: UnitPageGuide },
  'map.property': { title: 'Property Page', component: PropertyPageGuide },
  'property-list': { title: 'Property List', component: PropertyListGuide },
};
const currentGuide = computed(() => {
  const routeName = route.name;
  if (typeof routeName === 'string' && Guides[routeName]) {
    return Guides[routeName];
  }
  return null;
});
const hasSeenGuide = computedAsync<boolean>(async () => {
  const guideName = currentGuide.value?.title;
  if (guideName) {
    const result = await Preferences.get({
      key: `ncss-seen-guide-${guideName}`,
    });
    return result.value?.toLowerCase() === 'true';
  }
  return true;
}, true);

async function onClick() {
  if (currentGuide.value) {
    guideModal.value?.$el?.present();
    await Preferences.set({
      key: `ncss-seen-guide-${currentGuide.value.title}`,
      value: 'true',
    });
    triggerRef(currentGuide);
  }
}
</script>

<style scoped></style>
